const ShippingInstructions = (props) => {
  const { clubMembership } = props;
  if (
    !clubMembership.shippingInstructions ||
    clubMembership.shippingInstructions === ''
  ) {
    return null;
  }
  return (
    <div className="c7-order__customer-detail">
      <h4>Shipping Instructions</h4>
      <p>{clubMembership.shippingInstructions}</p>
    </div>
  );
};

export default ShippingInstructions;
